import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';
import { AlertasService } from '../core/_services/alerta.service';
import { CoreService } from '../core/_services/core.services';

@Component({
  selector: 'app-estado-proceso',
  templateUrl: './estado-proceso.component.html',
  styleUrls: ['./estado-proceso.component.scss']
})

export class EstadoProcesoComponent implements OnInit {

  columnas: any[] = [];
  totalRecords = 0;
  registros: any[] = [];
  formBuilder: FormBuilder;
  formularioFiltro: FormGroup;
  cargandoListaConsultas: boolean = true;
  buscar: boolean = false;

  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    private route: ActivatedRoute,
    public confirmationService: ConfirmationService,
    private breadCrumbService: AppBreadcrumbService
  ) {
    this.formBuilder = new FormBuilder();
  }

  ngOnInit(): void {

    this.columnas = [
      { field: 'requerimiento_id', header: 'Requerimiento' },
      { field: 'numero_id', header: 'Documento' },
      { field: 'descripcion', header: 'Estado Actual' },
    ];

    this.formularioFiltro = this.formBuilder.group({
      requerimiento: [''],
    })

  }

  getListado() {

    let params = {
      requerimiento_id: this.formularioFiltro.value.requerimiento,
    }
    if (params.requerimiento_id == '') {
      this.buscar = false;
    } else {
      this.coreService.getWithParams('/estado-proceso', params).subscribe(
        (res: any[]) => {
          this.buscar = true;
          this.registros = res;
          this.totalRecords = res.length;
        },
        (err: any) => {
          console.log(err);
        }
      )
    }
  }

  verInformeSeleccion(id: any) {

    this.coreService.viewPDF('/informe-seleccion/' + id).subscribe(
      (res: any) => {
        var archivoBlob = new Blob([res], { type: 'application/pdf' });
        var archivo = new File([archivoBlob], 'hoja_de_vida.pdf', { type: 'application/pdf' , lastModified: Date.now()});
        var url_archivo = URL.createObjectURL(archivo);
        window.open(url_archivo);
      },
      (err: any) => {
        console.log(err);
      }
    )

  }

}
